import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar'; 
import axios from 'axios';
import { BASE_URL } from './../../Environment';
import { toast } from 'react-toastify';
import Info from './Info';
import { format } from 'date-fns';
 
function Client() {
    const accessToken = localStorage.getItem('accessToken');
    const [isLoading, setIsLoading] = useState(false);
    const [client, setClient] = useState([]);
    useEffect(() => {
        document.title = 'Infomart | Agent Client';
        setIsLoading(true);
        axios.get(`${BASE_URL}/agent/client`, {  
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setClient(res.data.data);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
    }, []); 
    return (
        <div className="app"> 
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ?
                        <h5 className="text-center mt-5">Loading...</h5>
                    : 
                        <div className="card">
                            <div className="card-header fw-bold" style={{ whiteSpace: "nowrap" }}>Client</div>
                            {/* <div className="card-body">   */}
                            <div className="table-responsive">
                                <table className="table table-bordered" style={{ minWidth: "600px", width: "100%" }}>
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col" >Client</th> 
                                            <th scope="col" >Email ID</th> 
                                            <th scope="col" >WhatsApp</th> 
                                            <th scope="col" >Address</th>  
                                            <th scope="col" >Register Date</th>
                                        </tr> 
                                    </thead>
                                    <tbody className="align-middle">
                                        {client && client.length > 0 ? (
                                            client.map((data, i) => ( 
                                                <tr key={i}> 
                                                    <th scope="row">{i + 1}</th>
                                                    <td>
                                                        <b>{data.name}</b>
                                                        <br />
                                                        +91 {data.phone}
                                                    </td> 
                                                    <td>{data.email}</td> 
                                                    <td>+91 {data.whatsapp}</td>
                                                    <td>{data.address}</td>  
                                                    <td>{format(data.created_at, 'dd MMM, yyyy')}</td>
                                                </tr> 
                                            ))
                                        ) : (
                                            <tr>
                                                <th colSpan="6" className="text-center">No data available.</th>
                                            </tr>
                                        )}
                                    </tbody>
                                 </table> 
                                {/* </div> */}
                            </div>
                        </div>
                    }
                </div>
            </div> 
        </div>
    );
}

export default Client;            